/**
 * External Imports
 */
import { FC } from 'react';

/**
 * Internal Imports
 */

import supportRoundingTypes from '../../../constants/supportRoundingTypes.json';

/**
 * Style Imports
 */
import { StartNeuButton } from './Header.styles';

interface StartNewRoundBtnProps {
  disabled: boolean;
  handleStartNewRoundClick?: () => void;
  type: string;
}

const StartNewRoundButton: FC<StartNewRoundBtnProps> = ({
  disabled,
  handleStartNewRoundClick,
  type
}) => {
  const roundContent = supportRoundingTypes.validation.includes(type)
    ? 'Validation'
    : 'Round';

  return (
    <StartNeuButton
      data-testid={`start-new-${roundContent.toLowerCase()}-button`}
      disabled={disabled}
      size="small"
      onClick={disabled ? undefined : handleStartNewRoundClick}
    >
      Start a New {roundContent}
    </StartNeuButton>
  );
};

export default StartNewRoundButton;
